export default __webpack_public_path__ + "static/media/mapBackground.6cd81f1c.png";